
/**
 * List of Notes Type
 */
export enum NoteType {
    AmountAdjusted = 'Amount Adjusted',
    ClosedWithoutTransaction = 'Closed Without Transaction',
    Other = 'Other'
}